import { Video } from 'lucide-react';
import { cn } from '@/lib/utils';

type TransitionCameraIconProps = {
	className?: string;
};

/**
 * Visual da câmera/vídeo (origem dos balões). O posicionamento e o
 * encolhimento final ficam a cargo do orquestrador.
 */
const TransitionCameraIcon = ({ className }: TransitionCameraIconProps) => {
	return (
		<div
			className={cn(
				'relative flex size-[72px] items-center justify-center rounded-2xl bg-[#1f2a37] text-[#8ab4f8]',
				'shadow-[0_12px_34px_-10px_rgba(0,0,0,0.7)] ring-1 ring-[#8ab4f8]/25',
				className,
			)}
			aria-hidden
		>
			<span className="absolute inset-0 rounded-2xl bg-[#8ab4f8]/10 motion-safe:animate-ping" />
			<Video size={34} strokeWidth={2} className="relative" />
		</div>
	);
};

export { TransitionCameraIcon };
